'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotData = exports.SlotChange = void 0;
var tslib_1 = require("tslib");
var vue_class_component_1 = require("vue-class-component");
var functions_1 = require("./functions");
var vue_1 = tslib_1.__importDefault(require("vue"));
function getSlotContents(element, slotName) {
    var slotSelector = slotName
        ? "slot[name=" + slotName + "]"
        : 'slot:not([name])';
    var slotNode = element.querySelector(slotSelector);
    return slotNode ? slotNode.assignedElements() : [];
}
function onSlotChange(slot, element, immediate, callback) {
    if (immediate) {
        callback(getSlotContents(element, slot));
    }
    var handler = function () {
        callback(getSlotContents(element, slot));
    };
    element.addEventListener('slotchange', handler);
    return function () {
        element.removeEventListener('slotchange', handler);
    };
}
/**
 * Listens for slot change events on the web component and calls the
 * decorated method with the changes.
 * @param slot The slot name to use or none for default slot
 */
function SlotChange(slot, _a) {
    if (slot === void 0) { slot = ''; }
    var _b = _a === void 0 ? { immediate: true } : _a, immediate = _b.immediate;
    return vue_class_component_1.createDecorator(function (options, key) {
        if (!options.methods) {
            options.methods = {};
        }
        var functionToCall = options.methods[key];
        if (!functionToCall && typeof functionToCall !== 'function') {
            throw new Error('SlotChange decorator must be decorating a function call');
        }
        var unsub = null;
        options.mounted = functions_1.hookFunction(options.mounted, function () {
            unsub = onSlotChange(slot, this.$el, immediate, functionToCall.bind(this));
        });
        options.destroyed = functions_1.hookFunction(options.destroyed, function () {
            if (unsub) {
                unsub();
            }
        });
    });
}
exports.SlotChange = SlotChange;
function convertType(constructor, value, hasAttribute) {
    switch (constructor) {
        case Boolean:
            if (value === 'false' || !hasAttribute) {
                return false;
            }
            return true;
        case Number:
            return value ? +value : 0;
    }
    return value || '';
}
/**
 * Observes slot children and sets the decorated data property with an array of
 * all matching children and their attribute data.
 *
 * @example
 *       @SlotData('magic-option', ['value'])
 *       options: Array<{ value: string | null, }>
 *
 * @param childName
 * @param attributes
 * @param slotName
 */
function SlotData(childName, attributes, slotName) {
    if (slotName === void 0) { slotName = ''; }
    return vue_class_component_1.createDecorator(function (options, key) {
        var _a;
        var attributeNames = Object.keys(attributes);
        // Create a proxy object and set via vue to make it reactive.
        var observedData = vue_1.default.observable((_a = {},
            _a[key] = [],
            _a));
        options.computed = options.computed || {};
        options.computed[key] = {
            get: function () {
                return observedData[key];
            },
        };
        var unsub = null;
        var setAttributeData = function (nodes) {
            vue_1.default.set(observedData, key, nodes.map(function (node) {
                var data = {};
                attributeNames.forEach(function (attr) {
                    data[attr] = convertType(attributes[attr], node.getAttribute(attr), node.hasAttribute(attr));
                });
                return data;
            }));
        };
        options.mounted = functions_1.hookFunction(options.mounted, function () {
            var _this = this;
            var emitNodeChange = function () {
                setAttributeData(getSlotContents(_this.$el, slotName).filter(function (element) {
                    return (element.tagName.toLocaleUpperCase() ===
                        childName.toLocaleUpperCase());
                }));
            };
            var observer = new MutationObserver(emitNodeChange);
            var unsubSlotChange = onSlotChange(slotName, this.$el, true, function (nodes) {
                // MutationObserver cannot disconnect from just one node. We must disconnect from all and then add the new nodes...
                observer.disconnect();
                nodes.forEach(function (node) {
                    return observer.observe(node, {
                        attributes: true,
                        attributeFilter: attributeNames,
                    });
                });
                emitNodeChange();
            });
            unsub = function () {
                observer.disconnect();
                unsubSlotChange();
            };
        });
        options.destroyed = functions_1.hookFunction(options.destroyed, function () {
            if (unsub) {
                unsub();
            }
        });
    });
}
exports.SlotData = SlotData;
